import { render, staticRenderFns } from "./TabEquipeDistrital.vue?vue&type=template&id=03fa1367"
import script from "./TabEquipeDistrital.vue?vue&type=script&lang=ts"
export * from "./TabEquipeDistrital.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports